var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "body", locale: _vm.$root.$i18n.locale } },
    [
      _c("page-sidebar"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "side-right offset-lg-2", attrs: { id: "page" } },
        [
          _c(
            "div",
            { attrs: { id: "main-content" } },
            [_c("router-view", { key: _vm.routerViewKey })],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }